<template>
	<div class="fwry">
		<div class="fwrycontent">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
					<div class="ryitem" v-for="(item, index) in list" :key="index">
						<img :src="defaultimg" alt="" />
						<div class="zi">
							<div class="zileft">
								<span class="style1">{{ item.employeesName }}</span>
								<!-- <span>所在小区：{{ item.villageName }}</span> -->
							</div>
							<div class="ziright">
								<span>电话：{{ item.employeesPhone }}</span>
								<span>岗位：{{ item.post }}</span>
							</div>
						</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
</template>
<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum: 0,
				defaultimg: require('../../../assets/wyjj/tx.png'),
			};
		},
		computed: {
			...mapState(['userInfo', 'identity', 'houseId']),
		},
		mounted() {

		},
		methods: {
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					// 清空列表数据
					this.pageNum = 0;
					this.list = [];
					this.refreshing = false;
				}
				this.requestdata('/api/v1/wygl/property/view')
			},
			requestdata(url) {
				this.$axios.get(url, {
					params: {
						pageNum: this.pageNum,
						pageSize: 15,
						houseId: this.houseId,
					}
				}).then(res => {
					this.list.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	.fwry {
		.fwrycontent {
			padding: 10px;
			.ryitem {
				width: 100%;
				height: 80px;
				display: flex;
				align-items: center;
				border-radius: 10px;
				box-shadow: 0 0 10px #dadada;
				margin-bottom: 20px;

				img {
					margin-left: 20px;
					height: 50px;
					width: 50px;
				}

				.zi {
					margin-left: 20px;
					height: 80%;
					display: flex;
					justify-content: space-between;
					font-size: 13px;
					width: 100%;
					.zileft,
					.ziright {
						display: flex;
						flex-direction: column;
						justify-content: center;
						width: 50%;
					}
					.ziright{
						color: #999;
					}
				}

				.style1 {
					font-size: 16px;
				}
			}
		}
	}
</style>
